// ユーザーグループ編集画面でのユーザー選択状態をページネーション間で保持する処理
//
// data-*属性で受け取る値:
//   data-user-group-id      : ユーザーグループID（sessionStorageのキーに利用）
//   data-server-selections  : サーバー側で選択済みのユーザーID配列（JSON文字列）
//                             バリデーション失敗時のold()値もここに渡される
document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('user-group-form');
    if (!form) {
        return;
    }

    const groupId = form.dataset.userGroupId;
    if (!groupId) {
        return;
    }

    const storageKey = 'user_group_' + groupId + '_selected';

    // old()由来は文字列要素・DB由来は整数要素となるため、JSの厳密比較を考慮して数値に正規化
    let rawSelections = [];
    try {
        rawSelections = JSON.parse(form.dataset.serverSelections || '[]');
    } catch (e) {
        rawSelections = [];
    }
    const serverSelections = (Array.isArray(rawSelections) ? rawSelections : []).map(Number);

    // sessionStorageから保存済み選択状態を取得、なければサーバーの値を使用
    const stored = sessionStorage.getItem(storageKey);
    let selectedIds = stored !== null ? JSON.parse(stored) : [...serverSelections];

    // 現在のページのチェックボックスに選択状態を反映
    const checkboxes = document.querySelectorAll('input[name="user_ids[]"]');
    checkboxes.forEach(function(cb) {
        const id = parseInt(cb.value);
        cb.checked = selectedIds.includes(id);
        cb.addEventListener('change', function() {
            if (cb.checked) {
                if (!selectedIds.includes(id)) selectedIds.push(id);
            } else {
                selectedIds = selectedIds.filter(function(x) { return x !== id; });
            }
            sessionStorage.setItem(storageKey, JSON.stringify(selectedIds));
        });
    });

    // フォーム送信時に他ページの選択済みユーザーをhidden inputとして追加
    form.addEventListener('submit', function() {
        const visibleIds = Array.from(checkboxes).map(function(cb) { return parseInt(cb.value); });
        const offPageIds = selectedIds.filter(function(id) { return !visibleIds.includes(id); });
        offPageIds.forEach(function(id) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'user_ids[]';
            input.value = id;
            form.appendChild(input);
        });
        sessionStorage.removeItem(storageKey);
    });
});
